import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { UpdateEdoProfileSchema } from '@app/models/users';
import Api from '@app/services/api';

const edoProfileQueryKey = (legalEntityUid?: string | null) => ['edoProfile', legalEntityUid];

export const useLegalEntityQuery = (uid?: string | null) =>
  useQuery({
    queryKey: ['legalEntity', uid],
    queryFn: () => Api.users.getLegalEntity(uid as string),
    enabled: !!uid,
  });

export const useEdoProfileQuery = (legalEntityUid?: string | null) =>
  useQuery({
    queryKey: edoProfileQueryKey(legalEntityUid),
    queryFn: () => Api.users.getEdoProfile(legalEntityUid as string),
    enabled: !!legalEntityUid,
    retry: false,
  });

export const useUpdateEdoProfileMutation = (legalEntityUid: string) => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateEdoProfileSchema) => Api.users.putEdoProfile(legalEntityUid, data),
    onSuccess: (profile) => client.setQueryData(edoProfileQueryKey(legalEntityUid), profile),
  });
};
